import styled from 'styled-components';

export const Caption = styled.figcaption`
  color: ${(props): string => props.theme.palette.text.primary};
  padding: 1.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
